export const translations = {
    en: {
        title: "FastDev",
        subtitle: "Paste any code (JSON, XML, HTML) - we'll handle the rest.",
        placeholder: "Paste your code here...",
        startParsing: "Start Parsing",
        format: "Format",
        minify: "Minify",
        expand: "Expand",
        foldAll: "Fold",
        unfoldAll: "Unfold",
        copy: "Copy",
        clear: "Clear",
        convertXml: "To XML",
        convertJson: "To JSON",
        jsonTools: "JSON Tools",
        jsonDesc: "Instantly format, validate, and minify your JSON data. Our smart editor supports code folding, syntax highlighting, and error detection to help you debug api responses faster.",
        formatConversion: "Format Conversion",
        conversionDesc: "Seamlessly convert between JSON and XML. Whether you need to parse legacy XML data or convert JSON for enterprise systems, FastDev handles it with one click.",
        secureLocal: "Secure & Local",
        secureDesc: "All processing happens in your browser. Your code never leaves your device, ensuring maximum security for your sensitive data and tokens.",
        contact: "📮lsw@vip.qq.com",
        icp: "粤ICP备2025403162号",
        escapeLabel: "Retain Escape",
        langCode: "en"
    },
    zh: {
        title: "FastDev",
        subtitle: "粘贴代码 (JSON, XML, HTML) - 剩下的交给我们",
        placeholder: "在此粘贴代码...",
        startParsing: "开始解析",
        format: "格式化",
        minify: "压缩",
        expand: "展开",
        foldAll: "折叠",
        unfoldAll: "展开",
        copy: "复制",
        clear: "清空",
        convertXml: "转XML",
        convertJson: "转JSON",
        jsonTools: "JSON 工具",
        jsonDesc: "即时格式化、校验和压缩您的 JSON 数据。我们的智能编辑器支持代码折叠、语法高亮和错误检测，帮助您更快地调试 API 响应。",
        formatConversion: "格式转换",
        conversionDesc: "在 JSON 和 XML 之间无缝转换。无论您是需要解析旧版 XML 数据还是为企业系统转换 JSON，FastDev 都能一键搞定。",
        secureLocal: "安全 & 本地化",
        secureDesc: "所有处理均在您的浏览器中进行。您的代码从未离开您的设备，确保您的敏感数据和令牌的最大安全性。",
        contact: "📮lsw@vip.qq.com",
        icp: "粤ICP备2025403162号",
        escapeLabel: "保留转义",
        langCode: "zh"
    }
};
